/**
 * #panel-collapse preview column body: document peek header plus a fixture note.
 */
import { testIds } from '@/lib/test-ids'
import { DocumentPeekHeader } from '@/components/layout/shell'
import { PREVIEW_FLOOR } from './maater-ui-panel-collapse-layout'

const PREVIEW_FIELDS = [
  ['From', 'rowan@hopstudios.com'],
  ['Project', 'Hop Studios'],
  ['Status', 'Needs review'],
] as const

export function PanelCollapsePeek({ onClose, onOpen }: { onClose: () => void; onOpen: () => void }) {
  return (
    <>
      <DocumentPeekHeader
        kind="document"
        title="Late-todo shadow"
        path="hop-studios/internal/late-todo-shadow.md"
        onClose={onClose}
        onOpen={onOpen}
        testId={testIds.maaterUiGallery.panelCollapsePeekHeader}
        actionsTestId={testIds.maaterUiGallery.panelCollapsePeekActions}
      />
      <div className="min-h-0 flex-1 space-y-2 overflow-hidden p-3">
        <p className="truncate text-sm font-medium" style={{ color: 'var(--ink)' }}>
          Late-todo shadow
        </p>
        <div className="divide-y rounded-md border text-xs" style={{ borderColor: 'var(--line)' }}>
          {PREVIEW_FIELDS.map(([field, value]) => (
            <div key={field} className="flex items-center gap-3 px-2 py-1.5">
              <span className="w-14 shrink-0" style={{ color: 'var(--ink-faint)' }}>
                {field}
              </span>
              <span className="truncate" style={{ color: 'var(--ink)' }}>
                {value}
              </span>
            </div>
          ))}
        </div>
        <p className="text-[11px] leading-snug" style={{ color: 'var(--ink-soft)' }}>
          Under {PREVIEW_FLOOR}px this preview closes. It does not keep shrinking.
        </p>
      </div>
    </>
  )
}
